import { useState } from "react";
import { TENANT_DOMAIN } from "../../../utils/domain";
import { ERROR_MESSAGES } from "../../../constant/constant";
import { useAxios } from "../../../utils/useAxios";

/**
 * @typedef {object} DummyStudent
 * @property {number} id
 * @property {string} tenant_id
 * @property {number} inst_id
 * @property {string} name
 * @property {string} username
 * @property {number} is_pswd_reset
 * @property {string | null} email
 * @property {string} locale
 * @property {string} age
 * @property {number} role_id
 * @property {string} assigned_to
 * @property {string} createdBy
 * @property {string} class_id
 * @property {string} status
 * @property {string} created_at
 * @property {string} updated_at
 * @property {string} student_code
 */

/**
 * @description Custom hook to fetch the dummy student account
 */
export const useGetDummyStudent = () => {
  const [dummyStudent, setDummyStudent] = useState(
    /** @type {DummyStudent | null} */ (null)
  );
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const { axiosInstance } = useAxios();

  /**
   * Fetch the dummy student account details
   * @async
   */
  const getDummyStudent = async () => {
    try {
      setLoading(true);
      setError("");

      const url = `${TENANT_DOMAIN}/students/dummy`;

      const response = await axiosInstance.get(url);

      const data = response?.data?.data || null;
      setDummyStudent(data);
      return data;
    } catch (err) {
      setDummyStudent(null);
      if (err?.response?.status === 500) {
        setError(ERROR_MESSAGES.INTERNAL_SERVER);
      } else {
        setError(err?.response?.data?.message || ERROR_MESSAGES.UNKNOWN);
      }
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    dummyStudent,
    loading,
    error,
    getDummyStudent,
  };
};
